import React, { Fragment } from 'react'
import { Timeline, Typography } from 'antd'
import { map } from 'lodash'

import { EVENT_SUBTYPES, EVENT_TYPES } from '../../common/constants'
import {
  renderSimpleUpdateEvent,
  renderTreeSaveEvent,
} from '../../common/helpers'
import { formatCreatedByText } from '../../common/utils'

const renderChallengeEvent = event => {
  const { type, subtype, original, changes, createdAt, createdBy } = event

  if (type === EVENT_TYPES.SAVE) {
    return renderTreeSaveEvent(event)
  }

  if (subtype === EVENT_SUBTYPES.CHALLENGE_CUISINE_TYPES_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Added cuisine types for {changes.name}:
        </Typography.Text>
        <br />
        {map(changes.cuisineTypes, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.CHALLENGE_CUISINE_TYPES_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted cuisine types from {original.name}:
        </Typography.Text>
        <br />
        {map(original.cuisineTypes, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.CHALLENGE_DISH_TYPES_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>Added dish types for {changes.name}:</Typography.Text>
        <br />
        {map(changes.dishTypes, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.CHALLENGE_DISH_TYPES_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted dish types from {original.name}:
        </Typography.Text>
        <br />
        {map(original.dishTypes, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  return renderSimpleUpdateEvent(event, 'name')
}

export default renderChallengeEvent
